export default {
  title: 'Update contact',
  backButton: 'All contacts',
};
